import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.ExperienceList.title',
    defaultMessage: 'Experiences',
  },
  shift: {
    id: 'app.containers.ExperienceList.shift',
    defaultMessage: 'Shift',
  },
  backToExperienceList: {
    id: 'app.containers.ExperienceList.backToExperienceList',
    defaultMessage: 'Back to all experiences',
  },
});
